import { PublicSellerCenterSSOApiClient } from '@/apis';

export default {
  verifyVerificationTokenRedirect (oneTimeToken, options) {
    return PublicSellerCenterSSOApiClient.post('/verification-token-redirect', {
      redirectVerificationToken: oneTimeToken,
    }, options);
  },
};
